import { useCallback } from 'react';

import { selectCurseFilter } from '../selectors/conversation';
import { maybeRestartRecording } from '../store/slices/audioV2';
import { setCurseFilter } from '../store/slices/conversation';
import { useAppDispatch, useAppSelector } from '../store/store';

export const useCurseFilterSwitch = () => {
  const curseFilter = useAppSelector(selectCurseFilter);
  const dispatch = useAppDispatch();
  const toggleCurseFilter = useCallback(() => {
    const newValue = curseFilter === 2 ? 0 : 2;
    dispatch(setCurseFilter(newValue));
    dispatch(maybeRestartRecording());
  }, [curseFilter]);

  return { curseFilter, toggleCurseFilter };
};
